import { IDatasetBrief } from '../types/metadata';

export const isDatasetOfflineFromBriefs = (
  datasetId: string,
  datasetBriefs: IDatasetBrief[]
) => {
  return (
    datasetBriefs.find((brief) => brief.id === datasetId)?.isOffline ?? false
  );
};

export const isOfflineDatasetSelectionGuard = ({
  datasetId,
  datasetBriefs,
  setDatasetIsOfflineWarningVisible,
}: {
  datasetId: string;
  datasetBriefs: IDatasetBrief[];
  setDatasetOfflineText?: (text: string) => void;
  setDatasetIsOfflineWarningVisible: (visible: boolean) => void;
}) => {
  const isOffline = isDatasetOfflineFromBriefs(datasetId, datasetBriefs);

  if (isOffline) {
    setDatasetIsOfflineWarningVisible(true);
  }

  return isOffline;
};
